import React, { Component } from "react"
import "./Index.scss"
import DataHeader from "./containers/DataHeader"
import DataTable from "./containers/DataTable"
import dataIcon from "app/styles/images/sp/data-selected.svg"
import { observer } from "mobx-react"
import Store from "app/stores/preview/data_statistics"

@observer
export default class Index extends Component {
  constructor(props) {
    super(props)
    this.store = Store.fromJS()
  }

  render() {
    const { store } = this
    return (
      <div className="datastatistics-page preview-statistics">
        <h2 className="page-title"><img alt="" src={dataIcon} />数据管理</h2>
        <div className="clearfix wrapper-box-first">
          <DataHeader store={store} />
        </div>
        <div>
          <DataTable store={store} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/preview/data_statistics/index.js